













































































































































import {auth} from "@/scripts/firebase";
import firebase from 'firebase';
import {UserProfile, UserPublicProfile,UserPrivateProfile, NoticeProps } from "@/scripts/datatypes";
import { Component,Watch ,Mixins} from "vue-property-decorator";
import Notice from "@/components/Notice.vue";
import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
//import { ValidationResult } from 'vee-validate/dist/types/types';

//eslint-disable-next-line
const jaconv = require("jaconv")


/**
 * アップロード画像の内容チェック ファイル形式 サイズ
 * エラー表示
 */

@Component({
  components: {
    Notice,
  }
})

export default class Profile extends Mixins(Common) {
  isLoading = false
  isLoadingImage = false
  isDeletingImage = false
  profileImageSrc = ''
  profileImageNew = ''
  notice: NoticeProps = {}
  disabledUpdateProfile = true
  userMeta = {} as UserProfile
  uploadImageStatus = ''

/*
  get userDocRef(){
    return this.$getUserDocRef()
  }
*/

  @Watch('userMeta',{deep: true})
  async changeUserProfile(newVal: UserProfile, oldVal: UserProfile){

    if(Object.keys(oldVal).length ==  0 ){
      return
    }

    if(newVal.lastNameYomigana){
      newVal.lastNameYomigana = jaconv.toHiragana(jaconv.toZenKana(newVal.lastNameYomigana))
      newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    if(newVal.firstNameYomigana){
      newVal.firstNameYomigana = jaconv.toHiragana(jaconv.toZenKana(newVal.firstNameYomigana))
      newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    this.disabledUpdateProfile = false
  }

  async deleteProfileImage(){
    this.uploadImageStatus = 'Deleting'
    this.profileImageSrc = ''
    const data = {
      profileImage: ''
    }
    await this.$updateDoc(this.$getUserPublicProfileDocRef(),data)
    const result = await this.$waitUntilUpdatedForDoc(this.$getUserPublicProfileDocRef())
    this.uploadImageStatus = ''
  }

  async uploadProfileImage(e: Event){
    if(! e.target){
      return
    }

    const target = e.target as HTMLInputElement

    if(! target.files){
      return
    }

    this.$store.commit('setLoading',true)
    this.isLoadingImage = true

    this.uploadImageStatus = 'Uploading....'

    //console.log(e.target.files)
    
    const file = target.files[0]
    this.profileImageNew = file.name

    try{
      const userImagesRef = this.$getUserImagesRef()
   
      const profileImageFileName = Date.now()
      const profileRef = userImagesRef.child(`profile/${profileImageFileName}`)
      
      const uploadTask = await profileRef.put(file)
      this.uploadImageStatus = 'Generating Thumbnail'
      const userData = await this.$waitUntilUpdatedForDoc(this.$getUserPublicProfileDocRef())

      const profileImageThumbnailFileName = `${profileImageFileName}${this.$data.$profileThumbnailSize}`
      const profileThumbnailRef = userImagesRef.child(`profile/${profileImageThumbnailFileName}`)
      this.profileImageSrc = await profileThumbnailRef.getDownloadURL()
      this.uploadImageStatus = ''
    }catch(error){
      const errorCode = this.$getErrorCode(error)

      //const errorMessage0 = this.$t('resetPassword.error') as string
      
      const errorMessage1 = this.$getErrorMessage(errorCode)
      
      this.uploadImageStatus = errorMessage1
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoadingImage = false
    }
  }

  mounted(){
    console.log('mounted');
  }

  get observer(){
    return this.$refs.profileValidationObserver as InstanceType<typeof ValidationObserver>
  }

  async created() {
    console.trace('created')

    this.userMeta = {
      email: this.$store.state.user.email,
      ...this.$store.state.userPublicProfile,
      ...this.$store.state.userPrivateProfile
    }

    try{
      if(this.userMeta.profileImage){
        
        this.$store.commit('setLoading',true)
        this.isLoadingImage = true

        const profileImageFileName = `${this.userMeta.profileImage}${this.$data.$profileThumbnailSize}`

        const userImagesRef = this.$getUserImagesRef()
      
        const profileRef = userImagesRef.child(`profile/${profileImageFileName}`)

        this.profileImageSrc = await profileRef.getDownloadURL()
      }
     
    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoadingImage = false
    }
  }

  get languages(): string[]{
    if(this.$i18n.availableLocales){
      return this.$i18n.availableLocales
    }
    return [];
  }

  async updateProfile(){
    try{
      this.notice = {
				isShow: false,
      }
			
			if(await this.observer.validate()){
      
        const updateFields = {...this.userMeta}
        let field: keyof UserProfile
        for (field in updateFields) {
          if(! this.observer.fields[field] || this.observer.fields[field].dirty === false || this.observer.fields[field].changed === false) {
            delete(updateFields[field])
          }
        }

        console.table(updateFields)
        
        if(Object.keys(updateFields).length > 0){

          this.$store.commit("setLoading",true);
          this.isLoading = true

          const user = auth.currentUser// as firebase.User

          if(user && updateFields.displayName && updateFields.displayName !== this.$store.state.user.displayName){
            await user.updateProfile({
              displayName: updateFields.displayName
            })
            this.$store.commit("setUser",user);
          }

          if(updateFields.lang){
            const privateProfile: UserPrivateProfile = {lang: updateFields.lang}
            await this.$updateDoc(this.$getUserPrivateProfileDocRef(),privateProfile)
            await this.$waitUntilUpdatedForDoc(this.$getUserPrivateProfileDocRef())
            delete(updateFields.lang)
            console.log(updateFields)
          }

          if(Object.keys(updateFields).length > 0){
            const publicProfile: UserPublicProfile = {...updateFields}
            await this.$updateDoc(this.$getUserPublicProfileDocRef(),publicProfile)
            await this.$waitUntilUpdatedForDoc(this.$getUserPublicProfileDocRef())
          }
          

          this.notice = {
            message: this.$t('profile.updated') as string,
            isShow: true,
            type: {'is-success': true}
          }
          this.observer.reset()
        }else{
          this.notice = {
            message: this.$t('profile.noChangedFields') as string,
            isShow: true,
            type: {'is-info': true}
          }
        }
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$getErrorMessage(errorCode)

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      this.observer.reset()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateProfile = true
    }
  }

}
/*
 public async linkGoogleAuth(){
  const provider = new authObject.GoogleAuthProvider();
  const user = auth.currentUser;
  if(user == null){
    return;
  }
  
  try{
      await user.linkWithRedirect(provider);
  }catch(error) {
    console.log('linkGoogleAuth failed',error.code, error.message);
  }
 }

 */
